enum LocationRecommendationsLevel {
  Off = 0,
  Passive = 1,
  Active = 2,
  ModsOnly = 3,
}

export { LocationRecommendationsLevel };
